/**
 * NKBA API
 * The RESTful backend behind the NKBA application
 *
 * OpenAPI spec version: V1.0.0
 * Contact: cloud@nkba.org
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Activity {
    /**
     * globally unique id
     */
    id?: string;

    /**
     * type of activity
     */
    type?: Activity.Type;

    /**
     * subType of activity
     */
     subType?: Activity.Type;

    /**
     * quantity, for ORDER type
     */
    quantity?: number;

    /**
     * description of the action
     */
    description?: string;

    /**
     * for SUBSCRIPTION type, start date of period covered by dues
     */
    startDate?: string;

    /**
     * for SUBSCRIPTION type, end date of period covered by dues
     */
    endDate?: string;

    /**
     * created by user id
     */
    createId?: string;

    /**
     * for custom types, the specific type
     */
    customType?: string;

    /**
     * created timestamp
     */
    createAt?: string;

    /**
     * amount, for ORDER and SUBSCRIPTION type
     */
    amount?: number;

    /**
     * target entity id
     */
    entityId?: string;

    /**
     * internal note for NKBA staff only
     */
    note?: string;

    /**
     * units, for custom types
     */
    units?: number;

    /**
     * target entity type
     */
    entityType?: string;

}

export namespace Activity {

    export enum Type {
        NOTE = <any>'NOTE',
        CREATE = <any>'CREATE',
        UPDATE = <any>'UPDATE',
        DUES = <any>'DUES',
        POINTS = <any>'POINTS',
        MEMBER_APPLICATION = <any>'MEMBER_APPLICATION',
        MEMBER_REINSTATE = <any>'MEMBER_REINSTATE',
        MEMBER_REREGISTER = <any>'MEMBER_REREGISTER',
        MEMBER_TERMINATE = <any>'MEMBER_TERMINATE',
        ORDER = <any>'ORDER',
        MEETING = <any>'MEETING',
        EMAIL = <any>'EMAIL',
        LETTER = <any>'LETTER',
        CALL = <any>'CALL',
        INFO = <any>'INFO',
        AWARD = <any>'AWARD',
        REFUND = <any>'REFUND',
        COUPON = <any>'COUPON',
        CUSTOM = <any>'CUSTOM',
        EXPIRE = <any>'EXPIRE',
        BADGE_MEETING = <any>'BADGE_MEETING',
        BADGE_VIRTUAL = <any>'BADGE_VIRTUAL',
        CHAPTER_POSITION_HISTORY = <any>'CHAPTER_POSITION_HISTORY',
        LEARNING_PROGRAM_BADGE = <any>'LEARNING_PROGRAM_BADGE',
        LEARNING_PROGRAM_CERTIFICATION = <any>'LEARNING_PROGRAM_CERTIFICATION',
        INDIVIDUAL_LEARNING_PROGRAM_BADGE = <any>'INDIVIDUAL_LEARNING_PROGRAM_BADGE',
        CHAPTER_NOTE = <any>'CHAPTER_NOTE',
    }
}



// WEBPACK FOOTER //
// ./src/common/api/models/Activity.ts